import React from 'react';
import styled from '@benzinga/themetron';
import customStyles from '../customStyles';

export interface CryptoNewsListProps {
  news: NewsItem[];
}

interface NewsItem {
  date: string;
  title: string;
  url: string;
}

const NewsGroupContainer = styled.div`
  &:before {
    content: ' ';
    background: #ceddf2;
    display: block;
    height: 10px;
    width: 5px;
    border-bottom-right-radius: 10px;
    border-top-right-radius: 10px;
    position: relative;
    top: 19px;
    left: -16px;
    z-index: 2;
  }
`;

export const CryptoNewsList: React.FC<CryptoNewsListProps> = ({ news }) => {
  const groupByDate = () => {
    return news.reduce((acc, obj) => {
      const key = obj.date;
      if (!acc[key]) {
        acc[key] = [];
      }
      acc[key].push(obj);
      return acc;
    }, {});
  };
  const groupedNewsList = groupByDate();

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    const month = date.toLocaleString('default', { month: 'short' });
    const day = date.getUTCDate();
    const year = date.getFullYear();
    return `${month} ${day}, ${year}`;
  };

  return (
    <div className="bg-white flex flex-col h-full p-4 rounded" style={{ boxShadow: customStyles.boxShadow }} w-full>
      <div className="border-b border-gray-400 border-opacity-20 flex justify-between mb-2 pb-4">
        <h3 className="uppercase text-gray-700 font-semibold text-sm">Recent Cryptocurrency News</h3>
        <button className="text-blue-500 font-semibold uppercase text-sm" type="button">
          See more
        </button>
      </div>
      <div>
        {Object.keys(groupedNewsList).map(dateString => {
          const newsList: NewsItem[] = groupedNewsList[dateString];
          return (
            <NewsGroupContainer className="mb-2 last:mb-0 relative" key={dateString}>
              <div
                className="absolute block bg-gray-200"
                style={{
                  height: 'calc(100% - 30px)',
                  left: '-16px',
                  top: '28px',
                  width: '2px',
                }}
              />
              <div className="border-2 border-gray-200 font-bold p-1 rounded-full text-center text-gray-500 text-xs uppercase w-24">
                {formatDate(dateString)}
              </div>
              <ul>
                {newsList.map(newsItem => (
                  <li key={newsItem.title}>
                    <a
                      className="text-gray-800 font-semibold text-sm py-1 block"
                      href={newsItem.url}
                      rel="noopener noreferrer"
                      target="_blank"
                    >
                      {newsItem.title}
                    </a>
                  </li>
                ))}
              </ul>
            </NewsGroupContainer>
          );
        })}
      </div>
    </div>
  );
};
